
  
// Script Généré le : 10/01/2026 10:38:10 via ModelGenerator.nt
//  SupplierFamily.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\SupplierFamily.ts

import {Family } from "./Family";
import {Supplier } from "./Supplier";
export class SupplierFamily {

  // int SupplierId
  public SupplierId: number=0;

  // int FamilyId
  public FamilyId: number=0;

  // byte? MainFamily
  public MainFamily?: number=null;

  // Family Family
  public Family: Family=null;

  // Supplier Supplier
  public Supplier: Supplier=null;
}